module.exports = __webpack_public_path__ + "media/images/emoticons/snow-31e5d5937528ef789689de88f429f989.gif";